import script from "./AppScrollTopButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppScrollTopButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppScrollTopButton.vue?vue&type=style&index=0&id=f0b32544&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0b32544"]])

export default __exports__